<div class="EXTRA_SERVICE_FLIGHTS_FORM modal-header w-100 d-inline-block border-bottom pb-0 mb-0">
    <div class="d-flex justify-content-between">
      <h4 class="booking-modal-title">Flights</h4>
      <p class="modal-clost-btn" (click)="bsModalRef?.hide()" aria-label="Close">&times;</p>
    </div>
    <div>
    </div>
  </div>
  <div class="modal-body p-4 mt-3">
   <p class="my-3 intro">Our team are available on the go to assist & support with your flight request.</p>
    <form [formGroup]="form">
        <div class="form-group mb-3">
            <label class=" form-label">
              Enter Flight Location <span class="text-danger">*</span>
            </label>
            <div class="row">
                <div class="col-6 form-input">
                    <app-location-selector className="input-locator" placeholder="Flying from" [showErrorMsg]="false"
                    [showExample]="false" [showPrefixPadding]="false" [showPrefixIcon]="false"
                    (values)="locationChangeF($event)">
                  </app-location-selector>
                </div>
                <div class="col-6 form-input ">

                    <app-location-selector className="input-locator" placeholder="Flying to" [showErrorMsg]="false"
                    [showExample]="false" [showPrefixPadding]="false" [showPrefixIcon]="false"
                    (values)="locationChangeT($event)">
                  </app-location-selector>
                </div>

              </div>
        </div>
        <div class="form-group mb-3">
            <label class=" form-label">
              Travel Dates <span class="text-danger">*</span>
            </label>
            <div class="row">
                <div class="col-6 form-input">
                    <app-input [min]="minDate" (changeEvent)="getDate($event)" formCtrlName="travel_start" [label]="'Date'" [formGrp]="form" date [required]="true">
                    </app-input>
                </div>
                <div class="col-6 form-input ">

                    <app-input [min]="minDate" formCtrlName="travel_end" [label]="'Date'" [formGrp]="form" date [required]="true">
                    </app-input>
                </div>

              </div>
        </div>
        <div class="col-12 form-input mb-3">
            <label class="mt-2 form-label">
             Number of Travellers <span class="text-danger">*</span>
            </label>
            <app-input formCtrlName="number_of_travelers" [label]="'Amount'" inputNumber [formGrp]="form" [required]="true">
            </app-input>
        </div>
        <div class="col-12 form-input mb-3">
            <label class="mt-2 form-label">
             Cabin Preference <span class="text-danger">*</span>
            </label>
            <select class="form-control" formControlName="cabin_preference" name="" id="">
                <option value="economy" selected>Economy</option>
                <option value="business">Business</option>
                <option value="first-class">First Class</option>
            </select>
        </div>
        <div class="mb-3 ">

            <label class="mt-2 form-label form-toggle">
              Additional Request
            </label>
            <textarea formControlName="additional_requests" placeholder="Any special requests or preferences, such as specific airlines or meal options*" class="form-control form-input booking-text-area text-body"
              cols="10" rows="5"></textarea>


        </div>
        <app-button
                    class="book-btn"
                    [disabled]="form.invalid"
                    (click)="submit()"
                    [className]="'w-100'" warning>
                    {{loading ? 'Loading...': 'Submit'}}
                  </app-button>
    </form>


  </div>
